module.exports = __webpack_public_path__ + "img/xx／icon／24sm.c55ec898.svg";